/* ==========================================================================
   Paola & Joy — Instagram
   Arrow controls for the scrolling layout, and the optional live pull.
   ========================================================================== */

(function () {
  'use strict';

  /* ---- Scrolling layout --------------------------------------------------
     One page is one full run of visible tiles, so an arrow advances by what
     you can see rather than by a fixed pixel count. */
  function wireArrows(root) {
    var track = root.querySelector('[data-pj-ig-track]');
    if (!track || track.dataset.layout !== 'scroll') return;

    var arrows = root.querySelectorAll('[data-pj-ig-arrow]');
    if (!arrows.length) return;

    function refresh() {
      var max = track.scrollWidth - track.clientWidth - 1;
      arrows.forEach(function (a) {
        var back = parseInt(a.dataset.pjIgArrow, 10) < 0;
        a.disabled = back ? track.scrollLeft <= 0 : track.scrollLeft >= max;
      });
    }

    /* Honoured here rather than in CSS, since CSS scroll-behavior would also
       capture instant scrolls. */
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    arrows.forEach(function (a) {
      a.addEventListener('click', function () {
        track.scrollBy({
          left: track.clientWidth * parseInt(a.dataset.pjIgArrow, 10),
          behavior: reduce ? 'auto' : 'smooth'
        });
      });
    });

    track.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh);

    /* refresh() must not run only once. If it fires before the row has its
       final width, scrollWidth equals clientWidth, BOTH arrows disable, and
       nothing recovers it: a disabled button fires no click, and scroll and
       resize are the only other triggers. So re-check whenever the track or
       its contents actually change size, and once more after load for late
       images and webfonts. */
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(refresh);
      ro.observe(track);
      if (track.firstElementChild) ro.observe(track.firstElementChild);
    }
    window.addEventListener('load', refresh);
    requestAnimationFrame(refresh);
    refresh();
  }

  /* ---- Live pull ---------------------------------------------------------
     Instagram's Graph API, called straight from the browser. Only images and
     album covers are used; videos have no still worth showing at this size
     without also pulling a thumbnail, and a broken tile is worse than a
     shorter row. On any failure the markup already in the page is left alone,
     so a dead token degrades to whatever tiles were set rather than an empty
     section. */
  function loadLive(root) {
    if (root.dataset.source !== 'live') return;

    var token = root.dataset.token;
    var track = root.querySelector('[data-pj-ig-track]');
    if (!token || !track) return;

    var limit = parseInt(root.dataset.limit, 10) || 10;
    var fields = 'id,caption,media_type,media_url,thumbnail_url,permalink';
    var url = 'https://graph.instagram.com/me/media?fields=' + fields +
              '&limit=' + limit + '&access_token=' + encodeURIComponent(token);

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (body) {
        if (!body || !body.data || !body.data.length) return;

        var posts = body.data.filter(function (p) {
          return p.media_type === 'IMAGE' || p.media_type === 'CAROUSEL_ALBUM';
        }).slice(0, limit);

        if (!posts.length) return;

        track.innerHTML = '';
        posts.forEach(function (p) {
          var a = document.createElement('a');
          a.className = 'pj-ig__tile';
          a.href = p.permalink || '#';
          a.target = '_blank';
          a.rel = 'noopener noreferrer';

          var img = document.createElement('img');
          img.src = p.media_url || p.thumbnail_url;
          img.loading = 'lazy';
          /* Captions are long and often emoji-led; a trimmed caption makes a
             poor alt. The handle plus position is honest and quieter. */
          img.alt = (p.caption || '').trim().slice(0, 120) || 'Instagram post';

          a.appendChild(img);
          track.appendChild(a);
        });

        wireArrows(root);
      })
      .catch(function () { /* keep whatever is already rendered */ });
  }

  function init(root) {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    wireArrows(root);
    loadLive(root);
  }

  function boot() {
    document.querySelectorAll('[data-pj-ig]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-pj-ig]').forEach(function (el) {
      el.dataset.ready = 'false';
      init(el);
    });
  });
})();
